import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { ImageOff } from 'lucide-react'
import { cn } from '@/lib/utils'
import { isOptimizableImage } from '@/lib/media'

interface SmartImageProps {
    src: string | null | undefined
    alt: string
    sizes: string
    className?: string
    preload?: boolean
}

const SmartImage: FC<SmartImageProps> = ({ src, alt, sizes, className, preload = false }): ReactNode => {
    if (!src) {
        return (
            <div className={cn('absolute inset-0 flex items-center justify-center bg-muted text-muted-foreground/60', className)}>
                <ImageOff className='size-6' aria-hidden='true' />
            </div>
        )
    }

    if (isOptimizableImage(src)) {
        return (
            <Image
                src={src}
                alt={alt}
                fill
                sizes={sizes}
                preload={preload}
                className={cn('object-cover', className)}
            />
        )
    }

    return (
        // eslint-disable-next-line @next/next/no-img-element
        <img
            src={src}
            alt={alt}
            loading={preload ? 'eager' : 'lazy'}
            decoding='async'
            className={cn('absolute inset-0 size-full object-cover', className)}
        />
    )
}

export default SmartImage
